import React, { lazy, Suspense } from 'react';

// the real window is in RegisterModalContent.jsx and is downloaded the first time it is shown (it is only used after a click)
const RegisterModalContent = lazy(() => import('./RegisterModalContent'));

const RegisterModal = (props) => (
    <Suspense fallback={null}>
        <RegisterModalContent {...props} />
    </Suspense>
);

export default RegisterModal;
